import { Field, NumericInput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import React from 'react';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import ids from 'Components/Worksheets/QestIds';

const qestIds = [ids.soilClassification.ASTM.estimated_Psd];

let MeasuredSoilClassificationEstimatedPsdWorksheet = () => {
  return (
    <>
      <ListFieldSection>
        <Field input={<NumericInput />} label="Boulders (%)" name="BouldersPercentage" />
        <Field input={<NumericInput />} label="Cobbles (%)" name="CobblesPercentage" />
        <Field input={<NumericInput />} label="Gravel (%)" name="GravelPercentage" />
        <Field input={<NumericInput />} label="Sand (%)" name="SandPercentage" />
        <Field input={<NumericInput />} label="Fines (%)" name="FinesPercentage" />
      </ListFieldSection>
    </>
  );
};

MeasuredSoilClassificationEstimatedPsdWorksheet = withInjectedProps(MeasuredSoilClassificationEstimatedPsdWorksheet);

MeasuredSoilClassificationEstimatedPsdWorksheet.qestIds = qestIds;

export default MeasuredSoilClassificationEstimatedPsdWorksheet;
export { MeasuredSoilClassificationEstimatedPsdWorksheet };
